import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Paper,
  useTheme
} from '@mui/material';
import { stepFourStyles } from '../../styles/locationCampaign/stepFour';
import background from '../../assets/images/location_campaign/lemn.png';
import kozel from '../../assets/images/location_campaign/logo.png';
import premiu from '../../assets/images/location_campaign/premiu.png';
import despre_alcool from '../../assets/images/promo-despre-alcool.png';
import linie1 from '../../assets/images/location_campaign/linie1.png';

interface StepFourProps {
  onNext: () => void;
}

export default function StepFour({ onNext }: StepFourProps) {
  const theme = useTheme();

  return (
    <Box sx={stepFourStyles.container}>
      <Paper elevation={0} sx={stepFourStyles.paper(background)}>
          {/* Header */}
          <Box sx={stepFourStyles.header}>
            <Box
              component="img"
              src={kozel}
              alt="Kozel"
              sx={stepFourStyles.logo}
            />
          </Box>

          <Box sx={stepFourStyles.content}>
            {/* Main Title */}
            <Typography variant="h1" sx={stepFourStyles.mainTitle(theme)}>
              MEEEEEEREU ÎMPREUNĂ
            </Typography>
            
            <Typography variant="h4" sx={stepFourStyles.subtitle(theme)}>
              CÂȘTIGĂM PREMII
            </Typography>

             <Box sx={stepFourStyles.instructionsContainer}>
              <Typography variant="body1" sx={stepFourStyles.instructionsText2(theme)}>
                Felicitări! <br></br>
                Te-ai înscris cu succes!
              </Typography>
            </Box>

           {/* Prize Section */}
            <Box sx={stepFourStyles.prizeSection}>
              <Typography variant="h6" sx={stepFourStyles.prizeTitle}>
                TOMBOLĂ LA FINAL DE CAMPANIE
              </Typography>
              
              <Box sx={stepFourStyles.prizeContent}>
                <Box sx={stepFourStyles.prizeLeftSection}>
                  <Box sx={stepFourStyles.prizeCircle}>
                    <Typography sx={stepFourStyles.prizeCircleNumber}>
                      60
                    </Typography>
                    <Typography sx={stepFourStyles.prizeCircleText}>
                      x
                    </Typography>
                  </Box>
                  <Typography sx={stepFourStyles.prizeAmount}>
                    Voucher Emag 500 lei
                  </Typography>
                </Box>
                
                <Box
                  component="img"
                  src={premiu}
                  alt="Premiu Emag 500 LEI"
                  sx={stepFourStyles.prizeImageInSection}
                />
              </Box>
            </Box>

            {/* Linia 1 - înainte de instrucțiuni */}
            <Box sx={stepFourStyles.lineContainer}>
              <Box
                component="img"
                src={linie1}
                alt="Linia 1"
                sx={stepFourStyles.lineImage}
              />
            </Box>

            {/* Instructions */}
            <Box sx={stepFourStyles.instructionsContainer}>
              <Typography variant="body1" sx={stepFourStyles.instructionsText}>
                Păstrează bonul fiscal pentru validare. În caz de câștig, vei fi contactat prin SMS.
              </Typography>
            </Box>

            {/* Linia 2 - după instrucțiuni */}
            <Box sx={stepFourStyles.lineContainer}>
              <Box
                component="img"
                src={linie1}
                alt="Linia 2"
                sx={stepFourStyles.lineImage}
              />
            </Box>

            {/* More Receipts Section */}
            <Box sx={stepFourStyles.moreReceiptsContainer}>
              <Typography variant="body1" sx={stepFourStyles.moreReceiptsText}>
                Mai ai un bon?<br/>
                Poți înscrie până la 5 bonuri pe zi.
              </Typography>
            </Box>

            {/* Upload Button */}
            <Box sx={stepFourStyles.buttonContainer}>
              <Button
                variant="contained"
                onClick={onNext}
                sx={stepFourStyles.uploadButton}
              >
                ÎNCARCĂ
              </Button>
            </Box>

            {/* Footer Info */}
            <Box sx={stepFourStyles.footer}>
              <Box sx={stepFourStyles.footerImageContainer}>
                <Box
                  component="img"
                  src={despre_alcool}
                  alt="Despre alcool"
                  sx={stepFourStyles.footerImage}
                />
              </Box>
            </Box>
          </Box>
        </Paper>
    </Box>
  );
}